import PageContainer from "../shared/page-container";
import { getHomepageSectionDefinition } from "../../content/homepageSections";
import { useHomepageSectionContent } from "../../hooks/useHomepageSectionContent";

type IntroContent = {
  title?: string;
  paragraphs?: string[];
  heading?: {
    eyebrow?: string;
    title?: string;
    description?: string;
  };
};

export default function IntroStatement() {
  const fallback = getHomepageSectionDefinition("intro")?.defaultPayload as IntroContent;
  const { content, isInactive } = useHomepageSectionContent<IntroContent>("intro", fallback);

  if (isInactive) return null;

  const heading = content.heading || {};
  const title = content.title || heading.title || "Travel Beyond Borders, Designed Around You";
  const paragraphs = Array.isArray(content.paragraphs) && content.paragraphs.length
    ? content.paragraphs
    : heading.description
      ? [heading.description]
      : [];

  return (
    <section className="px-6 py-20 md:px-8 md:py-28 lg:px-12">
      <PageContainer className="max-w-4xl px-0 text-center">
          <h2 className="mb-4 font-serif text-4xl leading-tight text-[#0e302d] md:text-5xl">
           {title}
          </h2>

        {paragraphs.map((paragraph) => (
          <p key={paragraph} className="text-base leading-7 text-[#0e302d] md:text-lg">
            {paragraph}
          </p>
        ))}
      </PageContainer>
    </section>
  );
}
